/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CallExecutionStatus = {
    InProgress: 'IN_PROGRESS',
    Created: 'CREATED',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Error: 'ERROR',
    CallCompleteSuccess: 'CALL_COMPLETE_SUCCESS',
    CallCompleteError: 'CALL_COMPLETE_ERROR',
    FailedToProcess: 'FAILED_TO_PROCESS',
} as const;
export type CallExecutionStatus = typeof CallExecutionStatus[keyof typeof CallExecutionStatus];


export function instanceOfCallExecutionStatus(value: any): boolean {
    for (const key in CallExecutionStatus) {
        if (Object.prototype.hasOwnProperty.call(CallExecutionStatus, key)) {
            if (CallExecutionStatus[key as keyof typeof CallExecutionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CallExecutionStatusFromJSON(json: any): CallExecutionStatus {
    return CallExecutionStatusFromJSONTyped(json, false);
}

export function CallExecutionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallExecutionStatus {
    return json as CallExecutionStatus;
}

export function CallExecutionStatusToJSON(value?: CallExecutionStatus | null): any {
    return value as any;
}

export function CallExecutionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CallExecutionStatus {
    return value as CallExecutionStatus;
}

